import { createContext, useContext } from 'react';

/**
 * Provided by ReportsHub around inline report views so embedded reports can
 * return to the category card list without fighting URL↔state sync (which
 * would otherwise re-apply `?report=` from stale React state after navigate()).
 */
const ReportsHubNavigationContext = createContext(null);

export function ReportsHubNavigationProvider({ value, children }) {
  return (
    <ReportsHubNavigationContext.Provider value={value}>
      {children}
    </ReportsHubNavigationContext.Provider>
  );
}

export function useReportsHubNavigation() {
  return useContext(ReportsHubNavigationContext);
}
